import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ad-fuel-saving',
  templateUrl: './ad-fuel-saving.component.html',
  styleUrls: ['./ad-fuel-saving.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdFuelSavingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
